import logoSimpleWork from "../../../assets/logo/logo.png";
import logoErpWeb from "../../../assets/logo/erpweb.png";

const theme = () => {
  const layoutSimpleWork = {
    logo: logoSimpleWork,
    logoWidth: 200,
    theme: {
      primary: "#0066b3",
      secondary: "#72bf44",
      linearGradientPrimary: "linear-gradient(to right, #0083B0, #00B4DB)",
      linearGradientSecondary: "linear-gradient(to right, #72bf44, #a8e063)",
    },
  };

  const layoutErpWeb = {
    logo: logoErpWeb,
    logoWidth: 80,
    theme: {
      primary: "#2e3344",
      secondary: "#00AB5E",
      linearGradientPrimary: "linear-gradient(to right, #2e3344, #3b59bd)",
      linearGradientSecondary: "linear-gradient(to right, #00ab5e, #89ffca)",
    },
  };

  if (window.location.href.includes("erp-web")) {
    return layoutErpWeb;
  }
  return layoutSimpleWork;
};

export default theme;
